import { useContext } from "react";
import getBoard from "../Analyser/moodboardModel";
import BoardsContext from "./boardsContext";
import Moodboard from "./Moodboard";
import getBeepIds, { getSentBeeps } from "./getBeepIds";
import useTimeline from "../UserTimeline/useTimeline";
import useBeeps from "../UserTimeline/useBeeps";
import MoodboardLoading from "./MoodboardLoading";

export default function MoodboardList() {
  const { moodboards, activeBoardId, isLocalMoodboard } =
    useContext(BoardsContext);
  const { timeline } = useTimeline();
  const beepIds = () => {
    if (timeline === undefined || moodboards === undefined) return undefined; // loading
    if (moodboards === null || moodboards.length === 0) return []; // empty
    return [
      ...new Set(
        moodboards.flatMap((moodboard) => getBeepIds({ timeline, moodboard }))
      ),
    ]; // get all beepIds of moodboard
  };

  const { beeps } = useBeeps(
    beepIds(),
    timeline !== undefined && beepIds() !== undefined
  ); // prefetch all beeps if moodboard exists

  if (timeline === undefined || moodboards === undefined || beeps === undefined)
    return <MoodboardLoading />;
  if (moodboards !== null)
    return moodboards.map((moodboard, index) => (
      <Moodboard
        key={index}
        variant={isLocalMoodboard(activeBoardId) ? "localboard" : "publicboard"}
        index={index}
        board={getBoard(moodboard)}
        beepIds={getBeepIds({ timeline, moodboard })}
        sentBeeps={getSentBeeps({ timeline, moodboard })}
      />
    ));
  return "";
}
